<template>
    <v-btn text class="navbuttons" @click="$emit('click')" style="padding: 0 10px; letter-spacing: normal !important;">
        <div v-if="onlyLabel" class="actionsText--text" style="font-size: 13px; letter-spacing: normal !important;">
            {{label}}
        </div>
        <div v-else-if="typeof value === 'string'" class="actionsText--text"
            style="font-size: 13px; letter-spacing: normal !important;">
            <span v-if="value === ''">No {{label}} Specified</span>
            <span v-else>{{value}}</span>
        </div>
        <div v-else-if="value.length === 1" class="actionsText--text"
            style="font-size: 13px; letter-spacing: normal !important;">
            <span v-if="value[0] === ''">No {{label}} Specified</span>
            <span v-else>{{value[0]}}</span>
        </div>
        <div v-else class="actionsText--text" style="font-size: 13px; letter-spacing: normal !important;">
            {{value.length}} {{label}}
        </div>
        <v-icon
            color="actionsText"
            dark>
            mdi-chevron-down
        </v-icon>
    </v-btn>
</template>

<script>
    import { Items } from '../../ts/filters'

    export default {
        props: {
            filter: {
                required: false,
                type: Items,
                default: () => []
            },
            label: {
                required: false,
                type: String,
                default: ""
            },
            multiple: { // TODO: this should probably live in filter logic!
                required: false,
                type: Boolean,
                default: true
            },
            onlyLabel: {
                required: false,
                type: Boolean,
                default: false
            },
        },
        computed: {
            value() {
                const selected = this.filter.getSelected("text")
                return this.multiple ? selected : selected[0]
            },
        },
    }
</script>

<style scoped>
    .navbuttons {
        text-transform: capitalize;
        font-weight: normal;
        font-size: 13px;
    }
</style>